/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Actions from '../../../actions'
import dayjs from 'dayjs'
import Page from '../../common/Page'
import Card from '../../common/Card'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import isBetween from 'dayjs/plugin/isBetween'
import { gcpStorageUrl } from '../../../consts'
import useApplicationValidation from 'hooks/useApplicationValidation'
import { STEPS } from 'consts/flowConsts'

import './PlanRank.css'

dayjs.extend(isBetween)

const PlanRank = () => {
  const dispatch = useDispatch()
  useApplicationValidation()

  // this state will not affect on web view (only for mobile view)
  const [levelExpanded, setLevelExpanded] = useState(null)

  const rankingData = useSelector(state => state.plan?.rankingData)

  useEffect(() => {
    dispatch(Actions.createAction(Actions.PLAN_RANKS_REQUESTED))
  }, [])

  // init data
  const levels = rankingData?.map(level => ({
    name: level?.name,
    title: $t(`enroll.plans.planLevel.${level?.name}`),
    subtitle: $t(`enroll.plans.planLevel.${level?.name}Subtitle`),
    img: `${gcpStorageUrl}/${level?.name}.svg`,
    primaryAmount: level?.details?.primary_care_visits,
    specialistAmount: level?.details?.specialist_visit,
    prescriptionAmount: level?.details?.prescriptions,
    labsAmount: level?.details?.test_or_lab,
    emergencyAmount: level?.details?.emergency_room_visits,
    hospitalAmount: level?.details?.days_in_hospital
  }))

  const onProceed = rankLevel => {
    // proceed to next step
    dispatch(
      Actions.createAction(Actions.STEP_COMPLETED, { step: STEPS.PLAN_RANK })
    )
    dispatch(
      Actions.createAction(Actions.PLAN_RANK_SELECTED, { planRank: rankLevel })
    )
  }

  const getSubtitle = () => {
    return (
      <div className='sub column'>
        {$t('enroll.plans.subtitle')}
        <div className='semi-bold'> {$t('enroll.plans.subtitleBold')}</div>
      </div>
    )
  }

  const onExpand = index => {
    levelExpanded === index ? setLevelExpanded(null) : setLevelExpanded(index)
  }

  return (
    <Page
      loading={!rankingData?.length}
      className='enroll-plan-rank-page'
      title={$t('enroll.plans.title')}
      subtitle={getSubtitle()}
    >
      <div className='row plan-level-container'>
        {levels.map((level, index) => (
          <Card
            className='plan-level-card'
            key={index}
            onClick={() => onExpand(index)}
          >
            <img className='level-img' alt='' src={level.img} />
            <h2 className='plan-level-title semi-bold'>{level.title}</h2>
            <div className='plan-level-description'>{level.subtitle}</div>
            <div
              className={`expand-icon icon-arrow-bold-${
                levelExpanded === index ? 'up' : 'down'
              }`}
            />
            <div
              className='plan-level-amounts'
              data-expanded={levelExpanded === index}
            >
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.primaryAmount', {
                  count: level?.primaryAmount
                })}{' '}
                {$t('common.visit', {
                  count: level?.primaryAmount
                })}
              </div>
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.specialistAmount', {
                  count: level?.specialistAmount
                })}{' '}
                {$t('common.visit', {
                  count: level?.specialistAmount
                })}
              </div>
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.prescriptionAmount', {
                  count: level?.prescriptionAmount
                })}
              </div>
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.labsAmount', {
                  count: level?.labsAmount
                })}
              </div>
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.hospitalAmount', {
                  count: level?.hospitalAmount
                })}
              </div>
              <div className='plan-level-amount'>
                {$t('enroll.plans.planLevel.emergencyAmount', {
                  count: level?.emergencyAmount
                })}
              </div>
            </div>
            <Button
              className='continue-btn trackable'
              data-name={`see-${level?.name}-recommended-plans}`}
              data-expanded={levelExpanded === index}
              type='primary'
              onClick={() => onProceed(level?.name)}
            >
              {$t('enroll.plans.seeRecommended')}
            </Button>
          </Card>
        ))}
      </div>
      <Button
        className='see-all-btn trackable'
        data-name='see-all-plans'
        type='link'
        onClick={() => onProceed(null)}
      >
        {$t('enroll.plans.seeAll')}
      </Button>
    </Page>
  )
}

export default PlanRank
